/**
 * ส่วนลดของ cart (coupon) ที่ยังไม่ได้สร้าง order
 * ใช้ sync ไปยัง Customer Display เมื่อเปิด Order Summary dialog
 */

const STORAGE_KEY = "posCustomerDisplayCartDiscount";
const EVENT_NAME = "customer-display-cart-discount-updated";

export type CartDiscountItem = {
  label: string;
  amount: number;
};

export type CustomerDisplayCartDiscount = {
  discountTotal: number;
  discounts: CartDiscountItem[];
};

export function getCustomerDisplayCartDiscount(): CustomerDisplayCartDiscount | null {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as CustomerDisplayCartDiscount;
    if (
      typeof parsed?.discountTotal === "number" &&
      Array.isArray(parsed?.discounts)
    ) {
      return parsed;
    }
  } catch {
    localStorage.removeItem(STORAGE_KEY);
  }
  return null;
}

export function setCustomerDisplayCartDiscount(
  data: CustomerDisplayCartDiscount,
): void {
  if (typeof window === "undefined") return;
  if (data.discountTotal <= 0 && data.discounts.length === 0) {
    clearCustomerDisplayCartDiscount();
    return;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function clearCustomerDisplayCartDiscount(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function addCustomerDisplayCartDiscountListener(
  callback: () => void,
): () => void {
  const handler = () => callback();
  const storageHandler = (e: StorageEvent) => {
    if (e.key === STORAGE_KEY) callback();
  };
  window.addEventListener(EVENT_NAME, handler);
  window.addEventListener("storage", storageHandler);
  return () => {
    window.removeEventListener(EVENT_NAME, handler);
    window.removeEventListener("storage", storageHandler);
  };
}
